import { render, staticRenderFns } from "./examActivity.vue?vue&type=template&id=72707df3&scoped=true&"
import script from "./examActivity.vue?vue&type=script&lang=js&"
export * from "./examActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72707df3",
  null
  
)

export default component.exports